/* The Written Hug: ONE source of truth for on-screen handwriting stand-ins.
   The 38 pen styles are Cardly's own fonts, named as Cardly names them, and
   they are what the fulfilment Worker sends (STYLE_MAP in worker.js). The
   sprite files/twh-style-samples-cardly.png holds a real Cardly render of each
   one, 38 rows in this same alphabetical order. Each style maps to a Google
   webfont chosen by eye against that render (families may be shared), so
   changing the style always changes the preview. scale = size multiplier so
   every face reads at about the same x-height as Caveat; caps = the pen writes
   in capitals. Used by snippets/twh-personalize-js.liquid (product preview)
   and assets/twh-mf.js (homepage). The sprite is the real pen; these are
   close stand-ins. Handwrytten names were retired 2026-09-17. */
window.TWH_HAND=(function(){
  var M={
    "Adrian":["Give You Glory",0.7],
    "Angela":["Homemade Apple",0.7],
    "Anna":["Handlee",0.78],
    "Annie":["Patrick Hand",0.8],
    "Aurora":["La Belle Aurore",0.85],
    "Ben":["Shadows Into Light",0.7],
    "Benny":["Covered By Your Grace",0.7,1],
    "Blake":["Caveat",1.0],
    "Bron":["Delius",0.8],
    "Cammy":["Indie Flower",0.7],
    "Carmena":["Gochi Hand",0.62],
    "Chris":["Loved by the King",0.7],
    "Christina":["Shadows Into Light Two",0.7],
    "Dan":["Nothing You Could Do",0.72],
    "Dave":["Love Light",0.85,1],
    "Dawn":["Dancing Script",0.91],
    "Deborah":["Loved by the King",0.7],
    "Erin":["Cedarville Cursive",0.91],
    "Fiona":["Over the Rainbow",0.7],
    "Florent":["Annie Use Your Telescope",0.78],
    "Grace":["Kalam",0.78],
    "Jenna":["Architects Daughter",0.72,1],
    "John":["Nothing You Could Do",0.72],
    "Lee":["Schoolbell",0.75],
    "Maile":["Waiting for the Sunrise",0.75],
    "Michael":["Neucha",0.72],
    "Morgan":["Patrick Hand",0.8],
    "Moss":["Just Me Again Down Here",0.8],
    "Natalie":["Shadows Into Light Two",0.7],
    "Patrick":["Zeyada",0.87],
    "Paul":["Neucha",0.72,1],
    "Rosie":["Dawning of a New Day",0.91],
    "Sara":["Gochi Hand",0.72],
    "Shannon":["Coming Soon",0.72],
    "Simon":["Meddon",0.89],
    "Tom":["Reenie Beanie",0.9],
    "Trinity":["Delius",0.78],
    "Troy":["Grape Nuts",0.83]
  };
  var DEF='Blake';
  function e(n){return M[n]||M[DEF];}
  function family(n){return "'"+e(n)[0]+"',cursive";}
  function scale(n){return e(n)[1];}
  function caps(n){return !!e(n)[2];}
  function apply(el,n,base){
    if(!el)return;
    el.style.fontFamily=family(n);
    if(base)el.style.fontSize=(base*scale(n))+'px';
    el.style.textTransform=caps(n)?'uppercase':'';
  }
  function load(){
    if(document.getElementById('twh-hand-fonts'))return;
    var fam={},q=[];
    for(var k in M){var f=M[k][0];if(!fam[f]){fam[f]=1;q.push('family='+f.replace(/ /g,'+'));}}
    var l=document.createElement('link');l.id='twh-hand-fonts';l.rel='stylesheet';
    l.href='https://fonts.googleapis.com/css2?'+q.join('&')+'&display=swap';
    (document.head||document.documentElement).appendChild(l);
  }
  load();
  return {map:M,family:family,scale:scale,caps:caps,apply:apply};
})();
